import React, { useState, useEffect } from 'react'
import { Card, Button, Row, Form } from 'antd'
import { SchemaForm } from 'xadmin-form'
import { resetEmailForm, resetPhoneForm } from '../schema'
import { Icon, C } from 'xadmin-ui';
import app from 'xadmin'
import LogoComponent from './LogoComponent'

const DefaultLayout = props => {
  const { children, invalid, handleSubmit, onDelete, schema, submitting } = props;
  const { _t } = app.context;
  return (
    <Form className="form-horizontal" onSubmit={handleSubmit} layout="vertical">
      <Card style={{ marginTop: 0, borderTop: 'none' }}>
        {children}
        <Row>
          <Button type="primary" onClick={handleSubmit} disabled={invalid}>
            {_t(props.formKey == 'resetPhoneForm' ? '获取验证码' : '发送邮箱验证')}
          </Button>
        </Row>
      </Card>
    </Form>
  );
}

const ResetEmail = (props) => {
  const [ resetText, setResetText ] = useState('重置密码')
  const [ resetWays, setResetWays ] = useState('phone')

  useEffect(()=>{
    const ways = props.location && props.location.query && props.location.query.ways
    if(ways) {
      let isEmail = ways.indexOf('@')
      if(isEmail < 0) {
        //手机号
        setResetText('重置密码')
        setResetWays('phone')
      }else{
        //邮箱
        setResetText('邮箱重置密码')
        setResetWays('email')
      }
    }
  }, [ resetWays ])

  const onSubmit = (value) => {
    // console.log(value)
  }

  return (
    <div className="setGuideCard">
      <div className="guideContent">
        <div className="loginGuide" >
          <div className="loginBox">
            <LogoComponent></LogoComponent>
            <p className="guideUse">{resetText}</p>
          </div>
          {
            resetWays == 'email' ?
              <SchemaForm
                formKey={'resetEmailForm'}
                schema={resetEmailForm}
                component={DefaultLayout}
                group={C('Form.InlineGroup')}
                onSubmit={(value)=>onSubmit(value)}
              /> : 
              <SchemaForm
                formKey={'resetPhoneForm'}
                schema={resetPhoneForm}
                component={DefaultLayout}
                group={C('Form.InlineGroup')}
                onSubmit={(value)=>onSubmit(value)}
              />

          }
          <div className="loginBox">
            <p className="goReg resetNum" onClick={()=>app.go('/login')}>使用其他账号</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResetEmail
